const NEEDS_QUOTES = /[",\r\n]/;
const FORMULA_START = /^[=+\-@\t\r]/;
const PHONE = /^\+[\d\s\-()]+$/;

/** One cell, safe to open in Excel: quoted when it holds a comma, quote or line break, and a leading = + - or @
 * (which Excel would run as a formula) is defused with an apostrophe. Phone numbers keep their +. */
export function csvCell(value: string): string {
  const safe = FORMULA_START.test(value) && !PHONE.test(value) ? `'${value}` : value;
  return NEEDS_QUOTES.test(safe) ? `"${safe.replaceAll('"', '""')}"` : safe;
}

export function toCsv<T extends Record<string, string | number>>(rows: T[], columns: (keyof T & string)[]): string {
  const lines = [columns.join(','), ...rows.map((r) => columns.map((c) => csvCell(String(r[c]))).join(','))];
  return lines.join('\r\n');
}

/** Saves text as a CSV file. The byte-order mark makes Excel read names with accents correctly. */
export function downloadCsv(fileName: string, text: string): void {
  const url = URL.createObjectURL(new Blob(['﻿', text], { type: 'text/csv;charset=utf-8' }));
  const link = Object.assign(document.createElement('a'), { href: url, download: fileName });
  link.click();
  URL.revokeObjectURL(url);
}
